import React from "react";
import ModalGeneric from "../../../../../shared/components/generic/modal/modal-generic";
import AssessmentRulesContent from "../assessment-rules-content/assessment-rules-content";
import "./assessment-rules-modal.css";

const AssessmentRulesModal = ({ open, row, onClose }) => {
	const modalTitle = row
		? `${row.equipment} — ${row.client}`
		: "";

	return (
		<ModalGeneric
			id="assessment-rules"
			open={open}
			subtitle="Metas e Regras"
			title={modalTitle}
			onClose={onClose}
			className="assessment-rules-modal"
		>
			<AssessmentRulesContent rules={row?.rulesGoals} />
		</ModalGeneric>
	);
};

export default AssessmentRulesModal;